import { t } from 'i18next'
import { Chip, ChipProps } from '@mui/material';


type BillingInvoiceChipProps = {
    invoice: any
}

function BillingInvoiceChip({ invoice }: BillingInvoiceChipProps) {

    var chipColor: ChipProps['color'] = 'default';
    var chipLabel = ""

    switch (invoice.status) {
        case "paid":
            chipColor = "success"
            chipLabel = t("billing:paid")
            break;
        case "past_due":
            chipColor = "error"
            chipLabel = t("billing:past_due")
            break;
        case "open":
            if (invoice.amount_remaining > 0) {
                chipColor = "error"
                chipLabel = t("billing:past_due")
                break;
            }
            else {
                chipColor = "primary"
                chipLabel = t("billing:open")
                break;
            }

        default:
            chipColor = "default"
            chipLabel = ""
            break;
    }
    return (
        <Chip label={chipLabel} color={chipColor} size="small" />
    );
}

export default BillingInvoiceChip;